// Paridad diaria de `fetchNominacionesCrudas.ts` (Tarea 17): el reporte "Reconocimiento Diario" no
// tiene campaña — pagina `recognitionApi.exportRaw` por RANGO DE FECHAS en vez de por `campaignId`.
// Mismo LOTE/TOPE y misma condición de corte para que las dos hojas "Todos los reconocimientos"
// (Diario y Brillamos Juntos) se comporten igual ante un periodo con más de 5000 filas.
import { recognitionApi } from '@/api/recognition';
import type { NominationRawExportRowDto } from '@/api/recognition';
import type { NominacionesCrudasPaginadas } from './fetchNominacionesCrudas';

const LOTE_RECONOCIMIENTOS_CRUDOS = 200;
const TOPE_RECONOCIMIENTOS_CRUDOS = 5000;

/**
 * Pagina `recognitionApi.exportRaw` completo para el rango `[from, to]`, tope duro de
 * `TOPE_RECONOCIMIENTOS_CRUDOS` filas. Corta SOLO por página vacía o por el tope — NUNCA comparando
 * `filas.length` contra `res.total`: `total` cuenta RECONOCIMIENTOS, no filas, y uno grupal aporta
 * una fila por CANDIDATO (mismo criterio que `fetchNominacionesCrudasPaginado`).
 *
 * NO atrapa errores de red/HTTP: el caller (`DailyTab.tsx`) decide cómo mostrarlos.
 */
export async function fetchRecognitionsCrudoPaginado(
  from: string,
  to: string,
): Promise<NominacionesCrudasPaginadas> {
  const filas: NominationRawExportRowDto[] = [];
  let pagina = 1;
  do {
    const res = await recognitionApi.exportRaw(from, to, pagina, LOTE_RECONOCIMIENTOS_CRUDOS);
    if (res.filas.length === 0) break;
    filas.push(...res.filas);
    pagina += 1;
  } while (filas.length < TOPE_RECONOCIMIENTOS_CRUDOS);
  return { filas, truncado: filas.length >= TOPE_RECONOCIMIENTOS_CRUDOS };
}
